import script from "./BotVariablePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BotVariablePicker.vue?vue&type=script&setup=true&lang=js"

import "./BotVariablePicker.vue?vue&type=style&index=0&id=879871d4&scoped=true&lang=scss"
import "./BotVariablePicker.vue?vue&type=style&index=1&id=879871d4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-879871d4"]])

export default __exports__